import React from "react";
import { Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import FileList from "./fileList";

const BankProofUpload = ({ form, name = "files", readOnly, disabled }) => {
  const { t } = useTranslation();
  const locked = readOnly || disabled;
  const localOnly = !String(name).includes(".");

  return (
    <Box mt="sm">
      <Text size="sm" weight={500}>
        {t("Bank Proof")}
      </Text>
      <Text size="xs" color="dimmed" mb="xs">
        {t("Bank statement or card")}
      </Text>
      <FileList
        compact
        form={form}
        name={name}
        disabled={locked}
        manageFilesLocally={localOnly}
        onFilesChange={
          localOnly
            ? (updatedFiles) => form?.setFieldValue(name, updatedFiles)
            : undefined
        }
        uploadLabel="Drop bank statement or card, or click to browse"
        emptyLabel="No bank proof"
        showNoFilesMessage={false}
      />
    </Box>
  );
};

export default BankProofUpload;
